import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { useApi } from "../../../../hooks/useApi";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import AlertModal from "../../../Modal/AlertModal";
import ManagerPwInputModal from "../../../Modal/ManagerPwInputModal";
import ToolTip from "../../../Modal/ToolTip";
import { notiCaseSaveState } from "./SunsetAlimtalk/SunsetAlimtalk";
import { ISunsetData } from "./SunsetDetail/SunsetDetailInfo";
import { getAlTempNumber } from "./SunsetDetail/SunsetReason";
import { sunsetDetailDataState } from "./SunsetDetail/SunsetSubs";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

export const sunsetDetailButtonType = atom<
  "input" | "view" | "edit" | undefined
>({
  key: "sunsetDetailButtonType",
  default: undefined,
});

export default function SunsetDetailButtons() {
  const location = useLocation() as unknown as ISunsetData;
  const navigate = useNavigate();
  const { sunsetId } = useParams();

  const sunsetDetailData = useRecoilValue(sunsetDetailDataState);
  const notiCaseSave = useRecoilValue(notiCaseSaveState);
  const notiCaseSaveLength = sunsetDetailData?.sunsetType === 1 ? 6 : 5;
  const [buttonType, setButtonType] = useRecoilState(sunsetDetailButtonType);

  console.log(sunsetDetailData);
  console.log(notiCaseSave);

  const [pwInputModal, setPwInputModal] = useState({
    cancel: false,
    update: false,
    add: false,
  });

  const [askSunsetAddModal, setAskSunsetAddModal] = useState(false); // 일몰 추가 ask
  const [sunsetAdd, setSunsetAdd] = useState(false); // 일몰 추가 실행

  const [askSunsetCancelModal, setAskSunsetCancelModal] = useState(false); // 일몰 취소 ask
  const [sunsetCancel, setSunsetCancel] = useState(false); // 일몰 취소 실행

  const [askSunsetUpdateModal, setAskSunsetUpdateModal] = useState(false); // 일몰 수정 ask
  const [sunsetUpdate, setSunsetUpdate] = useState(false); // 일몰 수정 실행

  const notifyDate = dayjs(
    sunsetDetailData?.notifyDate !== ""
      ? sunsetDetailData?.notifyDate
      : undefined
  ).add(-1, "d");

  console.log(sunsetAdd);

  // 일몰 설정 추가
  const {
    response: addResponse,
    loading: addLoading,
    error: addError,
  } = useApi({
    method: "post",
    url: sunsetAdd ? `sunset` : undefined,
    data: {
      ssetSubs: sunsetDetailData?.sunsetSubsId ?? 0,
      srisSubs: sunsetDetailData?.sunriseSubsId ?? 0,
      ssetParty:
        sunsetDetailData?.sunsetParty === "0"
          ? []
          : sunsetDetailData?.sunsetParty
              .replace(/(\s*)/g, "")
              ?.split(",")
              ?.map((a) => +a),
      notifyDate: sunsetDetailData?.notifyDate ?? "",
      ssetDate: sunsetDetailData?.sunsetDate ?? "",
      sriseDate: sunsetDetailData?.sunriseDate ?? "",
      ssetType: sunsetDetailData?.sunsetType ?? 0,
      notifyType: sunsetDetailData?.notifyType ?? 0,
      altemp: +getAlTempNumber(sunsetDetailData?.sunsetReason ?? ""),
      customvar: {
        alertcat: sunsetDetailData?.sunsetReason ?? "",
      },
    },
  });

  // 일몰 설정 삭제
  const {
    response: cancelResponse,
    loading: cancelLoading,
    error: cancelError,
  } = useApi({
    method: "post",
    url: sunsetCancel ? `sunset/${sunsetId}/cancel` : undefined,
  });

  // 일몰 설정 수정
  const {
    response: updateResponse,
    loading: updateLoading,
    error: updateError,
  } = useApi({
    method: "post",
    url: sunsetUpdate ? `sunset/${sunsetId}` : undefined,
    data: {
      ssetSubs: sunsetDetailData?.sunsetSubsId ?? 0,
      srisSubs: sunsetDetailData?.sunriseSubsId ?? 0,
      ssetParty:
        sunsetDetailData?.sunsetParty === "0"
          ? []
          : sunsetDetailData?.sunsetParty
              .replace(/(\s*)/g, "")
              ?.split(",")
              ?.map((a) => +a),
      notifyDate: sunsetDetailData?.notifyDate ?? "",
      ssetDate: sunsetDetailData?.sunsetDate ?? "",
      sriseDate: sunsetDetailData?.sunriseDate ?? "",
      ssetType: sunsetDetailData?.sunsetType ?? 0,
      notifyType: sunsetDetailData?.notifyType ?? 0,
      altemp: +getAlTempNumber(sunsetDetailData?.sunsetReason ?? ""),
      customvar: {
        alertcat: sunsetDetailData?.sunsetReason ?? "",
      },
    },
  });

  useEffect(() => {
    if (
      cancelResponse?.status === 200 ||
      cancelResponse?.status === 201 ||
      updateResponse?.status === 200 ||
      updateResponse?.status === 201 ||
      addResponse?.status === 200 ||
      addResponse?.status === 201
    ) {
      toast.success(
        `일몰 설정이 ${
          addResponse ? "완료" : cancelResponse ? "삭제" : "변경"
        }되었습니다.`
      );
      navigate(`/linkid-manage/sunset`);
    }
  }, [cancelResponse, updateResponse, addResponse]);

  useEffect(() => {
    if (cancelError) {
      setSunsetCancel(false);
      toast.error(cancelError?.data ?? "일몰 설정 삭제에 실패하였습니다.");
    } else if (updateError) {
      setSunsetUpdate(false);
      toast.error(updateError?.data ?? "일몰 설정 변경에 실패하였습니다.");
    } else if (addError) {
      setSunsetAdd(false);
      toast.error(addError?.data ?? "일몰 설정에 실패하였습니다.");
    }
  }, [cancelError, updateError, addError]);

  return (
    <Flex gapSize={10}>
      <>
        {buttonType === "view" ? (
          <>
            {dayjs().diff(notifyDate) > 0 && (
              <ToolTip
                msg="일몰 설정 수정 기한이 지나 일몰 설정을 수정할 수 없습니다."
                direction="top"
              />
            )}

            <ConfirmBtn
              btnColor={"mint"}
              btnText={"일몰 설정 수정"}
              btnClickEvent={() => {
                setButtonType("edit");
              }}
              isDisabled={
                (dayjs().diff(notifyDate) > 0 ?? false) ||
                (location?.state?.sunsetData?.isexec === 2 ?? false)
              }
            />
          </>
        ) : buttonType === "edit" ? (
          <>
            <ConfirmBtn
              btnColor={"white"}
              btnText={"일몰 설정 삭제"}
              btnTextColor={"#f42d16"}
              btnClickEvent={() => setAskSunsetCancelModal(true)}
              isDisabled={
                (dayjs().diff(notifyDate) > 0 ?? false) ||
                (location?.state?.sunsetData?.isexec === 2 ?? false)
              }
            />

            <ConfirmBtn
              btnColor={"white"}
              btnText={"취소"}
              btnClickEvent={() => navigate("/linkid-manage/sunset")}
            />

            <ConfirmBtn
              btnColor={"mint"}
              btnText={"수정 완료"}
              btnClickEvent={() => setAskSunsetUpdateModal(true)}
              isDisabled={
                (dayjs().diff(notifyDate) > 0 ?? false) ||
                (location?.state?.sunsetData?.isexec === 2 ?? false) ||
                Object.values(notiCaseSave).filter((e) => e === true).length !==
                  notiCaseSaveLength
              }
            />
          </>
        ) : (
          <>
            <ConfirmBtn
              btnColor={"red"}
              btnText={"일몰 설정 완료"}
              isDisabled={
                Object.values(notiCaseSave).filter((e) => e === true).length !==
                notiCaseSaveLength
              }
              btnClickEvent={() => {
                setAskSunsetAddModal(true);
              }}
            />
          </>
        )}

        {/* 관리자 비밀번호 입력 */}
        {(pwInputModal.cancel || pwInputModal.update || pwInputModal.add) && (
          <ManagerPwInputModal
            closeEvent={() => {
              console.log(pwInputModal);

              if (pwInputModal.cancel) {
                setPwInputModal({
                  ...pwInputModal,
                  cancel: false,
                });
              } else if (pwInputModal.update) {
                setPwInputModal({
                  ...pwInputModal,
                  update: false,
                });
              } else {
                setPwInputModal({
                  ...pwInputModal,
                  add: false,
                });
              }
            }}
            confirmEvent={() => {
              console.log(pwInputModal);

              if (pwInputModal.cancel) {
                setSunsetCancel(true);
              } else if (pwInputModal.update) {
                setSunsetUpdate(true);
              } else {
                setSunsetAdd(true);
              }
            }}
            confirmBtnText={
              pwInputModal.add
                ? "일몰 설정 완료"
                : pwInputModal.cancel
                ? "일몰 설정 삭제"
                : "일몰 설정 변경"
            }
          />
        )}

        {/* 일몰 추가 ask 모달 */}
        {askSunsetAddModal && (
          <AlertModal
            title={`${sunsetDetailData?.sunriseSubsId}_${getSubsNameBySubsId3(
              sunsetDetailData?.sunriseSubsId ?? 0
            )}의 일몰 및
알림 설정이 추가됩니다.
계속하시겠습니까?`}
            confirmEvent={() => {
              setPwInputModal({
                ...pwInputModal,
                add: true,
              });
              setAskSunsetAddModal(false);
            }}
            cancelEvent={() => setAskSunsetAddModal(false)}
            confirmText="계속"
          />
        )}

        {/* 일몰 취소 ask 모달 */}
        {askSunsetCancelModal && (
          <AlertModal
            title={`${sunsetDetailData?.sunriseSubsId}_${getSubsNameBySubsId3(
              sunsetDetailData?.sunriseSubsId ?? 0
            )}의 일몰 및
알림 설정이 삭제됩니다.
계속하시겠습니까?`}
            confirmEvent={() => {
              setPwInputModal({
                ...pwInputModal,
                cancel: true,
              });
              setAskSunsetCancelModal(false);
            }}
            cancelEvent={() => setAskSunsetCancelModal(false)}
            confirmText="계속"
          />
        )}

        {/* 일몰 수정 ask 모달 */}
        {askSunsetUpdateModal && (
          <AlertModal
            title={`${sunsetDetailData?.sunriseSubsId}_${getSubsNameBySubsId3(
              sunsetDetailData?.sunriseSubsId ?? 0
            )}의 일몰 및
알림 설정이 변경됩니다.
계속하시겠습니까?`}
            confirmEvent={() => {
              setPwInputModal({
                ...pwInputModal,
                update: true,
              });
              setAskSunsetUpdateModal(false);
            }}
            cancelEvent={() => setAskSunsetUpdateModal(false)}
            confirmText="계속"
          />
        )}

        {(cancelLoading || updateLoading || addLoading) && <Loader />}
      </>
    </Flex>
  );
}
